/* eslint-disable sonarjs/no-duplicate-string */

import { defineMessages } from "react-intl";
import { useMessages } from "2g-hooks/intl";

const MESSAGES = defineMessages({
  cardsEmpty: {
    id: "b2b.provozni-informace-cards.empty",
    defaultMessage: "No operational information"
  },
  deleteDialogTitle: {
    id: "b2b.provozni-informace-card.delete-dialog.title",
    defaultMessage: "Delete operational information"
  },
  deleteDialogConfrimMesage: {
    id: "b2b.provozni-informace-card.delete-dialog.confrimMessage",
    defaultMessage: "Do you really want to delete the operational information?"
  }
});

export default () => useMessages(MESSAGES);
